import * as packageInfo from '../../package.json';
const packageJson = packageInfo;

export const environment = {
  production: true,
  type: 'production',
  appVersion: `${packageJson.version}`,
  authTokenKey: 'authce9d77b308c149d5992a80073637e4d5',
  urlV1: 'https://rsjsh.periqtsa.com/api/v1',
  urlV2: 'https://rsjsh.periqtsa.com/api/v2',
  urlGo: 'https://rsjsh.periqtsa.com',
  urlReportingGo: 'https://rsjsh.periqtsa.com',
  urlAiGemini: 'https://aigemini.periksaapis.com/ai-gemini-service',
  urlOcr: 'https://ocr.periksaapis.com',
  ocrApiKey: 'f422be32069917e5c5c237dcb72f44cfcd52e9546ec3b2dfa5e387fd90f4e7be',
  urlPaymentV1: 'https://dompet.periksa.net/v1',
  urlPaymentV2: 'https://dompet.periksa.net/v2',
  urlCoupon: 'https://coupon.periksa.tech/v1',
  urlMessaging: 'https://messenger.periksa.tech/v1.0.0',
  urlBff: 'https://backend-web-klinik.periksaapis.com',
  urlQueue: 'https://queue.periksaapis.com',
  urlFaceRecog: 'https://faces.periksa.tech/v1.0.0',
  urlSearchEngine: 'https://cari.periksa.tech/v1.0.0',
  urlBpjs: 'https://rsjsh.periqtsa.com/api/v2',
  urlPrintout: 'https://printout.periksaapis.com/v1',
  USERDATA_KEY: 'authf649fc9a5f55',
  klinik: 1,
  firebase: {
    apiKey: 'AIzaSyC1xkoVdH2flmCz-JTwnzdctIHsd1dfpZ8',
    authDomain: 'superapp-periksa.firebaseapp.com',
    projectId: 'superapp-periksa',
    storageBucket: 'superapp-periksa.appspot.com',
    messagingSenderId: '169432919070',
    appId: '1:169432919070:web:ea699a314afae53a66920f',
    measurementId: 'G-9244QZWL3E',
  },
  urlIconBucket: 'https://icons-rwji6t52cv3rp6f8.s3.ap-southeast-1.amazonaws.com/logos',
  apiId: 'klinik.periksa.id',
  apiPass: 'PYfi6cyFC6JDkRaU',
  apiSecret: 'R;x8KQDBEOiQ=m$Wkwd[eH62^zF6ms',
  bffApiPass: 'BFeJ8jZYSHp6x@6Y',
  encKey: 'XUKcD86TqxlFi3KWGTT3kS8UqVw8A1Gp',
};
